import { deletePasskey } from '@pba/client-auth';
import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { getPasskeysListQueryKey } from '../keys';

export const useDeletePasskey = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, { passkeyId: string }>({
    async mutationFn({ passkeyId }) {
      return deletePasskey({ routeParams: { id: passkeyId } });
    },

    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: getPasskeysListQueryKey({}) });
    },
  });
};
